import React from 'react';
import { formatDetailedTime, formatDate, getBrandingText } from '../templateUtils';

const PolaroidTemplate = ({
  language = 'zh',
  calculatedDays = 0,
  relationshipLabel = '在一起',
  detailedTime = null,
  anniversaryDate = null,
  anniversaryType = 'couple',
  quote = ''
}) => {
  const s = 3.375;

  return (
    <div
      style={{
        width: '1080px', height: '1350px',
        background: 'linear-gradient(135deg, #e8dcc8 0%, #d4c5b0 100%)',
        overflow: 'hidden', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        padding: `${12 * s}px`, fontFamily: 'Arial, sans-serif',
        boxSizing: 'border-box'
      }}
    >
      {/* 白色相框 */}
      <div style={{
        width: '100%', height: '100%', background: '#ffffff',
        boxShadow: `0 ${8 * s}px ${25 * s}px rgba(0,0,0,0.25)`,
        padding: `${14 * s}px ${14 * s}px ${40 * s}px ${14 * s}px`,
        position: 'relative', boxSizing: 'border-box'
      }}>

        {/* 照片內容區 */}
        <div style={{
          width: '100%', height: `calc(100% - ${40 * s}px)`,
          background: 'linear-gradient(135deg, #f5e6d3 0%, #e8d4bf 50%, #d4b5a0 100%)',
          position: 'relative', overflow: 'hidden'
        }}>
          {/* 紙張紋理 */}
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139,69,19,0.02) 2px, rgba(139,69,19,0.02) 4px)', opacity: 0.5 }} />

          {/* 主內容 */}
          <div style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', flexDirection: 'column', padding: `${20 * s}px ${16 * s}px ${16 * s}px ${16 * s}px` }}>

            {/* 頂部愛心 */}
            <div style={{ textAlign: 'center', marginBottom: `${12 * s}px` }}>
              <svg xmlns="http://www.w3.org/2000/svg" width={`${42 * s}`} height={`${42 * s}`} viewBox="0 0 24 24">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#8b4513" opacity="0.8" />
              </svg>
            </div>

            {/* 中間內容 */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
              <div style={{ fontSize: `${66 * s}px`, fontWeight: '800', color: '#3e2723', lineHeight: '1', marginBottom: `${8 * s}px`, fontFamily: 'Arial, sans-serif', letterSpacing: `${-2 * s}px`, opacity: 0.9 }}>
                {calculatedDays}
              </div>
              <div style={{ fontSize: `${15 * s}px`, fontWeight: '600', color: '#5d4037', marginBottom: `${14 * s}px`, opacity: 0.85 }}>
                {language === 'zh' ? `${relationshipLabel}的日子` : `days ${relationshipLabel}`}
              </div>
              {detailedTime && (
                <div style={{ fontSize: `${11 * s}px`, color: '#5d4037', fontWeight: '500', marginBottom: `${12 * s}px`, padding: `${5 * s}px ${12 * s}px`, background: 'rgba(255,255,255,0.7)', borderRadius: `${15 * s}px`, border: `${1 * s}px solid rgba(139,69,19,0.3)`, display: 'inline-block' }}>
                  {formatDetailedTime(detailedTime, language)}
                </div>
              )}
              {quote && (
                <div style={{ fontSize: `${9.5 * s}px`, color: '#5d4037', fontStyle: 'italic', lineHeight: '1.5', paddingLeft: `${12 * s}px`, paddingRight: `${12 * s}px`, opacity: 0.8 }}>
                  "{quote}"
                </div>
              )}
            </div>

            {/* 底部信息 */}
            <div style={{ textAlign: 'center', paddingTop: `${12 * s}px` }}>
              {anniversaryDate && (
                <div style={{ fontSize: `${9 * s}px`, color: '#5d4037', marginBottom: `${5 * s}px`, opacity: 0.8 }}>
                  {formatDate(anniversaryDate, language)}
                </div>
              )}
              <div style={{ fontSize: `${10 * s}px`, fontWeight: '700', color: '#8b4513', textTransform: 'uppercase', letterSpacing: `${0.5 * s}px`, marginBottom: `${3 * s}px` }}>
                {getBrandingText(anniversaryType, language)}
              </div>
              <div style={{ fontSize: `${8 * s}px`, color: '#5d4037', opacity: 0.7 }}>
                lovedays.homy.hk
              </div>
            </div>
          </div>
        </div>

        {/* 白框底部簽名區 */}
        <div style={{
          position: 'absolute', bottom: `${8 * s}px`,
          left: `${14 * s}px`, right: `${14 * s}px`,
          height: `${24 * s}px`, display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          fontSize: `${10 * s}px`, color: '#8b4513',
          fontStyle: 'italic', opacity: 0.5
        }}>
          Our Love Story ♡
        </div>
      </div>
    </div>
  );
};

export default PolaroidTemplate;